import React from 'react'

interface TextoNumericoProps {
  value: string
  onChange: (value: string) => void
  placeholder?: string
  className?: string
  onFocus?: () => void
  onBlur?: () => void
}

export const TextoNumerico: React.FC<TextoNumericoProps> = ({
  value,
  onChange,
  placeholder,
  className = '',
  onFocus,
  onBlur
}) => {
  // Função para filtrar apenas números
  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const inputValue = e.target.value
    
    // Permite apenas dígitos
    const numericValue = inputValue.replace(/[^0-9]/g, '')
    
    onChange(numericValue)
  }

  return (
    <input
      type="text"
      value={value || ''}
      onChange={handleInputChange}
      onFocus={onFocus}
      onBlur={onBlur}
      placeholder={placeholder}
      className={`w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-brand-500 focus:border-transparent transition-all duration-200 text-sm ${className}`}
    />
  )
}
